import type { BackgroundColor } from '@/components/Container'

import AccordionItem from './AccordionItem'

export interface AccordionProps {
  items: {
    title: string
    content: string
  }[]
  className?: string
  lightText?: 'solid'
  background?: BackgroundColor
}

const Accordion = ({ items, className, lightText, background }: AccordionProps) => (
  <ul>
    {items?.map(({ title, content }, index) => (
      <AccordionItem
        background={background}
        lightText={lightText}
        title={title}
        key={`acc_item_${index}`}
        content={content}
        className={className}
      />
    ))}
  </ul>
)

export default Accordion
